<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { TeamMember } from "./team.js";

	const { tenant } = getGlobalTemplateProps();
	const { teamMember }: { teamMember: TeamMember } = $props();

	const { default: defaultImage, ...sourceset } = $derived(teamMember.image);
</script>

<div class="flex flex-col gap-5">
	<Media
		width={200}
		height={100}
		source={{ type: "webp", src: defaultImage }}
		sourcesets={sourceset}
		alt={teamMember.name}
		class="w-74"
	/>
	<div class="pl-5.5">
		<div class="text-black font-antipol font-bold text-6/tighter">
			<Formatted text={teamMember.name} />
		</div>
		<div class="text-black text-base/normal mt-2.5">
			<Formatted text={teamMember.jobTitle[tenant.locale]} />
		</div>
	</div>
</div>
